import { APP_ROUTES } from './routes'

export const INBOX_NOTIFICATION_TYPE = {
  orderAssigned: 'order_assigned',
  inquiryCreated: 'inquiry_created',
} as const

export type InboxNotificationType =
  (typeof INBOX_NOTIFICATION_TYPE)[keyof typeof INBOX_NOTIFICATION_TYPE]

export type InboxNotificationPayload = {
  orderId?: string
  orderNumber?: string
  inquiryId?: string
}

export type InboxNotification = {
  id: string
  type: InboxNotificationType
  title: string
  body: string
  payload: InboxNotificationPayload
  readAt: string | null
  createdAt: string
}

export const NOTIFICATION_LIST_LIMIT = 20
export const NOTIFICATION_POLL_MS = 8_000
export const NOTIFICATION_BADGE_CAP = 9
export const NOTIFICATION_RING_MS = 1_200
export const NOTIFICATION_RECONNECT_MS = 3_000
export const NOTIFICATION_RECONNECT_MAX_MS = 30_000
/** Refresh the access token this long before it expires, so the stream reconnects cleanly. */
export const ACCESS_TOKEN_REFRESH_SKEW_MS = 60_000

export const NOTIFICATIONS = {
  bellLabel: 'Notifications',
  menuTitle: 'Notifications',
  empty: 'No notifications yet. New orders will show up here.',
  loadError: 'Could not load notifications.',
  markAll: 'Mark all read',
  ordersPath: APP_ROUTES.orders,
} as const

export type NotificationListProps = {
  items: InboxNotification[]
  loading: boolean
  error: string
  onOpen: (item: InboxNotification) => void
}

export type NotificationBellProps = {
  items: InboxNotification[]
  unreadCount: number
  loading: boolean
  error: string
  ringing: boolean
  onOpenItem: (item: InboxNotification) => void
  onMarkAllRead: () => void
}
